// extracted by mini-css-extract-plugin
export default {"chatContent":"TableChat_chatContent__Hy2vZ"};